import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import Snippet from 'components/Snippet';
import MediaXlUp from 'components/Responsive/MediaXlUp';

import Advert from './Advert';
import Welcome from './Welcome';

class Infobar extends React.Component {
  renderAdvert = () => {
    const { advert } = this.props;
    if (!(advert && advert.url && advert.image)) {
      return null;
    }
    const { image, url } = advert;
    return <Advert image={image} url={url} />;
  }

  renderWelcome = () => {
    const { currentArea, name } = this.props;
    if (!name || !currentArea || !currentArea.name) {
      return null;
    }
    return (
      <Welcome name={name} currentAreaName={currentArea.name} />
    );
  }

  /**
   * render
   * @return {Object}
   */
  render() {
    return (
      <MediaXlUp>
        <div className="col-tertiary">
          <div className="col-1-of-3">
            <div className="travel">
              {this.renderWelcome()}
              <br />
              <br />
              {this.renderAdvert()}
              <Snippet />
            </div>
          </div>
        </div>

      </MediaXlUp>

    );
  }
}

Infobar.displayName = 'Infobar';

Infobar.propTypes = {
  advert: PropTypes.shape({
    image: PropTypes.string.isRequired,
    url: PropTypes.string.isRequired,
  }),
  currentArea: PropTypes.shape({
    name: PropTypes.string,
  }),
  name: PropTypes.string,
};

Infobar.defaultProps = {
  advert: undefined,
  currentArea: undefined,
  name: undefined,
};

const mapStateToProps = ({
  myself: { character: { name } },
  infoBar: { advert, snippets },
  map: { currentArea },
}) => ({
  advert,
  currentArea,
  snippets,
  name,
});

export default connect(mapStateToProps)(Infobar);
